import { render } from "./informerentabilidadtrabajosoperarioscompanyias.vue?vue&type=template&id=2a530414&scoped=true"
import script from "./informerentabilidadtrabajosoperarioscompanyias.vue?vue&type=script&lang=js"
export * from "./informerentabilidadtrabajosoperarioscompanyias.vue?vue&type=script&lang=js"

import "./informerentabilidadtrabajosoperarioscompanyias.vue?vue&type=style&index=0&id=2a530414&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a530414"]])

export default __exports__